import { format, parse } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const formatDateForDisplay = (dateString: string | null): string => {
  if (!dateString) return 'Data não informada';
  
  try {
    // Para datas simples (YYYY-MM-DD), mantenha exatamente como está
    if (dateString.includes('-') && !dateString.includes('T')) {
      const [year, month, day] = dateString.split('-');
      return `${day}/${month}/${year}`;
    }
    
    // Para timestamps completos (com T), use date-fns normalmente
    if (dateString.includes('T')) {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return 'Data inválida';
      return format(date, 'dd/MM/yyyy', { locale: ptBR });
    }
    
    return 'Data inválida';
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Data inválida';
  }
};

export const formatDateTimeForDisplay = (dateString: string | null): string => {
  if (!dateString) return 'Data não informada';
  
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Data inválida';
    return format(date, "dd/MM/yyyy, HH:mm", { locale: ptBR });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Data inválida';
  }
};

export const parseDateString = (dateStr: string): string | null => {
  if (!dateStr) return null;
  
  try {
    // Converte de DD/MM/YYYY para YYYY-MM-DD
    const [day, month, year] = dateStr.split('/');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  } catch (error) {
    console.error('Error parsing date:', error);
    return null;
  }
};

export const isValidISODate = (dateString: string): boolean => {
  if (!dateString) return false;
  
  // Verifica se está no formato YYYY-MM-DD
  const regex = /^\d{4}-\d{2}-\d{2}$/;
  if (!regex.test(dateString)) return false;
  
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  
  return date.getFullYear() === year &&
         date.getMonth() === month - 1 &&
         date.getDate() === day;
};